"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCXFigRunWithFigData = exports.DOCXFigRun = exports.HTMLFigRunWithFigData = exports.HTMLFigRun = exports.HTMLFigRunCSS = void 0;
const react_1 = __importDefault(require("react"));
const html_1 = require("../common/html");
const component_1 = require("../common/docx/component");
const tags_1 = require("../common/docx/tags");
const util_1 = require("../../util");
exports.HTMLFigRunCSS = `
.fig-iframe {
    width: 100%;
    height: 80vh;
    border: 1px solid gray;
}

.fig-img {
    max-width: 100%;
}
`;
exports.HTMLFigRun = (0, html_1.wrapHTMLComponent)("HTMLFigRun", ((props) => {
    const { el, htmlOptions } = props;
    const { getFigData } = htmlOptions;
    if (el.children.length > 0) {
        throw new util_1.NotImplementedError(el.outerXML());
    }
    if (getFigData) {
        const figData = getFigData(el.attr.src);
        return figData === null ? (react_1.default.createElement(react_1.default.Fragment, null,
            "[",
            el.attr.src,
            "]")) : (react_1.default.createElement(exports.HTMLFigRunWithFigData, { ...props, figData: figData, fig: el }));
    }
    else {
        return (react_1.default.createElement("span", { className: "fig-src", ...(0, html_1.elProps)(el, htmlOptions) }, el.attr.src));
    }
}));
const HTMLFigRunWithFigData = (props) => {
    const { el, figData, htmlOptions, fig } = props;
    const { renderPDFAsLink } = htmlOptions;
    return (figData.type.startsWith("image/")
        ? (react_1.default.createElement("img", { className: "fig-img", src: figData.url, ...(0, html_1.elProps)(fig, htmlOptions) }))
        : ((!renderPDFAsLink) && figData.type.includes("pdf"))
            ? (react_1.default.createElement("iframe", { className: "fig-iframe", src: figData.url, sandbox: "allow-scripts", ...(0, html_1.elProps)(fig, htmlOptions) }))
            : (react_1.default.createElement("a", { className: "fig-link", href: figData.url, type: figData.type, target: "_blank", rel: "noreferrer", ...(0, html_1.elProps)(fig, htmlOptions) }, el.attr.src)));
};
exports.HTMLFigRunWithFigData = HTMLFigRunWithFigData;
exports.DOCXFigRun = (0, component_1.wrapDOCXComponent)("DOCXFigRun", ((props) => {
    const { el, docxOptions } = props;
    const { figDataManager } = docxOptions;
    if (el.children.length > 0) {
        throw new util_1.NotImplementedError(el.outerXML());
    }
    if (figDataManager) {
        const figData = figDataManager.getFigData(el.attr.src);
        return figData === null ? (react_1.default.createElement(tags_1.w.r, null,
            react_1.default.createElement(tags_1.w.t, null, el.attr.src))) : (react_1.default.createElement(exports.DOCXFigRunWithFigData, { ...props, figData: figData, fig: el, figDataManager: figDataManager }));
    }
    else {
        return (react_1.default.createElement(tags_1.w.r, null,
            react_1.default.createElement(tags_1.w.t, null, el.attr.src)));
    }
}));
const DOCXFigRunWithFigData = (props) => {
    const { figData, figDataManager } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        ("image" in figData) && (react_1.default.createElement(tags_1.w.r, null,
            react_1.default.createElement(tags_1.w.drawing, null,
                react_1.default.createElement(tags_1.wp.inline, null,
                    react_1.default.createElement(tags_1.wp.extent, { cx: figData.image.cx, cy: figData.image.cy }),
                    react_1.default.createElement(tags_1.wp.effectExtent, { l: "0", t: "0", r: "0", b: "0" }),
                    react_1.default.createElement(tags_1.wp.docPr, { id: figData.image.id, name: figData.src }),
                    react_1.default.createElement(tags_1.a.graphic, { "xmlns:a": "http://schemas.openxmlformats.org/drawingml/2006/main" },
                        react_1.default.createElement(tags_1.a.graphicData, { uri: "http://schemas.openxmlformats.org/drawingml/2006/picture" },
                            react_1.default.createElement(tags_1.pic.pic, { "xmlns:pic": "http://schemas.openxmlformats.org/drawingml/2006/picture" },
                                react_1.default.createElement(tags_1.pic.nvPicPr, null,
                                    react_1.default.createElement(tags_1.pic.cNvPr, { id: figData.image.id, name: figData.src }),
                                    react_1.default.createElement(tags_1.pic.cNvPicPr, null,
                                        react_1.default.createElement(tags_1.a.picLocks, { noChangeAspect: "1", noChangeArrowheads: "1" }))),
                                react_1.default.createElement(tags_1.pic.blipFill, null,
                                    react_1.default.createElement(tags_1.a.blip, { "r:embed": figData.image.rId }),
                                    react_1.default.createElement(tags_1.a.srcRect, null),
                                    react_1.default.createElement(tags_1.a.stretch, null,
                                        react_1.default.createElement(tags_1.a.fillRect, null))),
                                react_1.default.createElement(tags_1.pic.spPr, null,
                                    react_1.default.createElement(tags_1.a.xfrm, null,
                                        react_1.default.createElement(tags_1.a.off, { x: "0", y: "0" }),
                                        react_1.default.createElement(tags_1.a.ext, { cx: figData.image.cx, cy: figData.image.cy })),
                                    react_1.default.createElement(tags_1.a.prstGeom, { prst: "rect" },
                                        react_1.default.createElement(tags_1.a.avLst, null)))))))))),
        ("file" in figData) && (react_1.default.createElement(tags_1.w.r, null,
            react_1.default.createElement(tags_1.w.object, null,
                react_1.default.createElement(tags_1.v.shape, { id: `icon_${figData.file.id}`, style: { width: "39pt", height: "51pt" } },
                    react_1.default.createElement(tags_1.v.imagedata, { "r:id": figDataManager.pdfIcon.rId, "o:title": "" })),
                react_1.default.createElement(tags_1.o.OLEObject, { Type: "Embed", ProgID: "Acrobat.Document.DC", ShapeID: `icon_${figData.file.id}`, DrawAspect: "Icon", ObjectID: figData.file.id, "r:id": figData.file.rId })))),
        ("pages" in figData) && figData.pages.map((page, key) => (react_1.default.createElement(tags_1.w.r, { key: key },
            react_1.default.createElement(tags_1.w.drawing, null,
                react_1.default.createElement(tags_1.wp.inline, null,
                    react_1.default.createElement(tags_1.wp.extent, { cx: page.cx, cy: page.cy }),
                    react_1.default.createElement(tags_1.wp.effectExtent, { l: "0", t: "0", r: "0", b: "0" }),
                    react_1.default.createElement(tags_1.wp.docPr, { id: page.id, name: page.name }),
                    react_1.default.createElement(tags_1.a.graphic, { "xmlns:a": "http://schemas.openxmlformats.org/drawingml/2006/main" },
                        react_1.default.createElement(tags_1.a.graphicData, { uri: "http://schemas.openxmlformats.org/drawingml/2006/picture" },
                            react_1.default.createElement(tags_1.pic.pic, { "xmlns:pic": "http://schemas.openxmlformats.org/drawingml/2006/picture" },
                                react_1.default.createElement(tags_1.pic.nvPicPr, null,
                                    react_1.default.createElement(tags_1.pic.cNvPr, { id: page.id, name: page.name }),
                                    react_1.default.createElement(tags_1.pic.cNvPicPr, null,
                                        react_1.default.createElement(tags_1.a.picLocks, { noChangeAspect: "1", noChangeArrowheads: "1" }))),
                                react_1.default.createElement(tags_1.pic.blipFill, null,
                                    react_1.default.createElement(tags_1.a.blip, { "r:embed": page.rId }),
                                    react_1.default.createElement(tags_1.a.srcRect, null),
                                    react_1.default.createElement(tags_1.a.stretch, null,
                                        react_1.default.createElement(tags_1.a.fillRect, null))),
                                react_1.default.createElement(tags_1.pic.spPr, null,
                                    react_1.default.createElement(tags_1.a.xfrm, null,
                                        react_1.default.createElement(tags_1.a.off, { x: "0", y: "0" }),
                                        react_1.default.createElement(tags_1.a.ext, { cx: page.cx, cy: page.cy })),
                                    react_1.default.createElement(tags_1.a.prstGeom, { prst: "rect" },
                                        react_1.default.createElement(tags_1.a.avLst, null)),
                                    react_1.default.createElement(tags_1.a.ln, { w: "6350" },
                                        react_1.default.createElement(tags_1.a.solidFill, null,
                                            react_1.default.createElement(tags_1.a.srgbClr, { val: "888888" }))))))))))))));
};
exports.DOCXFigRunWithFigData = DOCXFigRunWithFigData;
//# sourceMappingURL=figRun.js.map